export type HeaderState = {
  languageSwitchMode: 'closed' | 'open'
  mobileMenuMode: 'closed' | 'open'
  searchString: string
}

export const headerStateUpdaters = {
  updateMobileMenuMode:
    (newMode: 'closed' | 'open') =>
    (currentState: HeaderState): HeaderState => ({
      ...currentState,
      mobileMenuMode: newMode,
    }),
  updateLanguageMode:
    (newMode: 'closed' | 'open') =>
    (currentState: HeaderState): HeaderState => ({
      ...currentState,
      languageSwitchMode: newMode,
    }),
}

export const defaultHeaderState: HeaderState = {
  mobileMenuMode: 'closed',
  languageSwitchMode: 'closed',
  searchString: '',
}
